import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import BottomBar from '../components/BottomBar';
import back from '../assets/icon/back.svg';
import './OrderingTest.css';

const bismillahRegex = /^بِسْمِ\s*[ٱا]للَّهِ\s*[ٱا]لرَّحْمَٰنِ\s*[ٱا]لرَّحِيمِ/;

const OrderingTest = () => {
  const [searchParams] = useSearchParams();
    const navigate = useNavigate();
  const surahParam = searchParams.get('surah');
  const modeParam = searchParams.get('mode') || 'full';
  const startParam = parseInt(searchParams.get('start'), 10);
  const endParam = parseInt(searchParams.get('end'), 10);

  const [surahName, setSurahName] = useState('');
  const [pagesData, setPagesData] = useState({});
  const [pageNumbers, setPageNumbers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);  const [shuffled, setShuffled] = useState([]);
  const [sequence, setSequence] = useState([]);
  const [result, setResult] = useState(null);
  const [showBasmalah, setShowBasmalah] = useState(false);
  const [score, setScore] = useState(null);
  const [ayahStatuses, setAyahStatuses] = useState([]);
  const [dragIndex, setDragIndex] = useState(null);
  const draggedAyahRef = useRef(null);






  useEffect(() => {
    if (!surahParam) return;

    fetch(`https://api.alquran.cloud/v1/surah/${surahParam}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
          let list = data.data.ayahs.map((a) => ({
            number: a.numberInSurah,
            text: a.text,
            page: a.page,

          }));

          if (modeParam === 'range') {
            if (
              !isNaN(startParam) &&
              !isNaN(endParam) &&
              startParam >= 1 &&
              endParam <= list.length &&
              startParam <= endParam
            ) {
              list = list.slice(startParam - 1, endParam);
            }
          }

          const surahNum = parseInt(surahParam, 10);
          const hasBasmalah = surahNum !== 9; // all surahs except Tawbah start with basmalah

          if (list.length > 0) {
            const first = list[0];
            const cleaned = first.text.replace(bismillahRegex, '').trim();
            const basmalahFound = cleaned !== first.text;

            if (basmalahFound) {
              if (cleaned === '') {
                // Remove the first ayah entirely when it's just the basmalah
                list.shift();
              } else {
                // Remove basmalah from the first ayah's text
                list[0].text = cleaned;
              }
            }

            setShowBasmalah(basmalahFound);
          } else {
            setShowBasmalah(false);
          }

          setSurahName(data.data.name);
          const grouped = {};
          list.forEach((a) => {
            if (!grouped[a.page]) grouped[a.page] = [];
            grouped[a.page].push(a);
          });
          const numbers = Object.keys(grouped)
            .map((n) => parseInt(n, 10))
            .sort((a, b) => a - b);
          setPagesData(grouped);
          setPageNumbers(numbers);
          setCurrentPage(0);
          if (numbers.length > 0) {
            setShuffled(shuffle(grouped[numbers[0]]));
          } else {
            setShuffled([]);
          }
          setSequence([]);
          setResult(null);
          setAyahStatuses([]);

        }
      })
      .catch((err) => console.error(err));
  }, [surahParam, modeParam, startParam, endParam]);
  useEffect(() => {
    if (pageNumbers.length > 0) {
      const page = pageNumbers[currentPage];
      if (pagesData[page]) {
        setShuffled(shuffle(pagesData[page]));
        setSequence([]);
        setResult(null);
        setAyahStatuses([]);

      }
    }
  }, [currentPage, pageNumbers, pagesData]);

  const currentAyahs =
    pageNumbers.length > 0 ? pagesData[pageNumbers[currentPage]] || [] : [];



  const shuffle = (arr) => {
    const array = [...arr];
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  const handleDragStart = (index) => {
    setDragIndex(index);
  };
  
  const handleButtonDragStart = (ayah) => {
    draggedAyahRef.current = ayah;
  };

  const handleButtonDragEnd = () => {
    draggedAyahRef.current = null;
  };

  const handleDropOnSequence = () => {
    if (draggedAyahRef.current) {
      selectAyah(draggedAyahRef.current);
      draggedAyahRef.current = null;
    }
  };

  const handleDragEnter = (index) => {
    if (dragIndex === null || dragIndex === index) return;
    const updated = [...sequence];
    const [removed] = updated.splice(dragIndex, 1);
    updated.splice(index, 0, removed);
    setDragIndex(index);
    setSequence(updated);
  };

  const handleDragEnd = () => {
    setDragIndex(null);
  };

  const selectAyah = (item) => {
    setSequence([...sequence, item]);
    setShuffled(shuffled.filter((a) => a.number !== item.number));
    setAyahStatuses([]);

  };
  const removeAyah = (item) => {
    setSequence(sequence.filter((a) => a.number !== item.number));
    setShuffled([...shuffled, item]);
    setAyahStatuses([]);

  };

  const goToNextPage = () => {
    if (currentPage < pageNumbers.length - 1) {
      setCurrentPage(currentPage + 1);
      setAyahStatuses([]);

    }
  };
  const restartPage = () => {
    const page = pageNumbers[currentPage];
    if (pagesData[page]) {
      setShuffled(shuffle(pagesData[page]));
    }
    setSequence([]);
    setResult(null);
    setScore(null);
  };
  const checkOrder = () => {
    const total = currentAyahs.length || 1;
    const statuses = currentAyahs.map((a, idx) =>
        sequence[idx]?.number === a.number ? 'correct' : 'wrong'
      );
      setAyahStatuses(statuses);
      const correctCount = statuses.filter((s) => s === 'correct').length;
    const pageScore = (correctCount / total) * 10;
    setScore(parseFloat(pageScore.toFixed(2)));
    const allCorrect = correctCount === total;
    setResult(allCorrect ? 'correct' : 'wrong');
  };

  return (
    <div className="ordering-test">
      <div className="test-header">
        <div className="back-icon-container">
          <img
            className="back-icon"
            src={back}
            alt="back"
            onClick={() => navigate(-1)}
          />
        </div>
        <h1 className="test-title">اختبار الترتيب</h1>
      </div>
      {surahName && <h2 className="surah-name">{surahName}</h2>}
      {showBasmalah && currentPage === 0 && (
        <div className="bismillah">بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ</div>
      )}
    <div
      className="selected-sequence"
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDropOnSequence}
    >    {sequence.map((ay, idx) => (
          <span
            key={ay.number}
            className={`selected-ayah ${ayahStatuses[idx] === 'correct' ? 'correct-ayah' : ayahStatuses[idx] === 'wrong' ? 'wrong-ayah' : ''} ${dragIndex === idx ? 'dragging' : ''}`}
            draggable
            onDragStart={() => handleDragStart(idx)}
            onDragEnter={() => handleDragEnter(idx)}
            onDragEnd={handleDragEnd}
            onClick={() => removeAyah(ay)}
          >        
            {ay.text}
            <span className="ayah-number">
              {currentAyahs.length > 0
                ? currentAyahs[0].number + idx
                : idx + 1}
            </span>
          </span>
        ))}
      </div>
      <div className="ayah-buttons">
        {shuffled.map((ay) => (
          <button
          key={ay.number}
          onClick={() => selectAyah(ay)}
          draggable
          onDragStart={() => handleButtonDragStart(ay)}
          onDragEnd={handleButtonDragEnd}
        >
            {ay.text}
            {/* <button className="remove-btn" onClick={() => removeAyah(ay)}>×</button> */}
          </button>
        ))}
      </div>
      {/* <div className="selected-sequence">
        {sequence.map((ay) => (
          <span key={ay.number} className="selected-ayah">
            {ay.text}
          </span>
        ))}
      </div> */}
            <p>صفحة {pageNumbers[currentPage]}</p>

      {shuffled.length === 0 && sequence.length > 0 && result === null && (
        <button className="check-button" onClick={checkOrder}>
          تحقق
        </button>
      )}
      {result === 'correct' && (
        <div>
          <p className="correct">أحسنت! الترتيب صحيح</p>
          <p>الدرجة: {score}/10</p>
          {currentPage < pageNumbers.length - 1 ? (
            <button className="check-button" onClick={goToNextPage}>
              الصفحة التالية
            </button>
          ) : (
            <p className="correct">انتهى الاختبار</p>
          )}
        </div>
      )}
      {result === 'wrong' && (
        <div>
          <p className="wrong">الترتيب غير صحيح</p>
          <p>الدرجة: {score}/10</p>
          <button className="check-button" onClick={restartPage}>إعادة الاختبار</button>
        </div>
      )}
      {/* <BottomBar /> */}
    </div>
  );
};

export default OrderingTest;